import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setBlood_GrpMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addBlood_Grp, updateBlood_Grp } from "services/blood_grpService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const Blood_GrpForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue={blood_grp_id:0,blood_grp_name:'',is_active:''};
    const initialValue = action === 'edit' ? row : iValue;
    
    
    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateBlood_Grp(row.blood_grp_id,values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setBlood_GrpMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setBlood_GrpMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addBlood_Grp(values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setBlood_GrpMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setBlood_GrpMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
           blood_grp_name: yup.string().required('blood_grp_name is required'),
is_active: yup.boolean().required('is_active is required'),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Blood_Grp
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Blood_Grp</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group>
<label className="form -control-label">blood_grp_name</label>
<Form.Control type="text" name="blood_grp_name" className="form-control" value={formik.values.blood_grp_name}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.blood_grp_name && !!formik.errors.blood_grp_name}
isValid ={!!formik.touched.blood_grp_name && !formik.errors.blood_grp_name}
></Form.Control>
{
    formik.errors.blood_grp_name && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.blood_grp_name}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">is_active</label>
<Form.Control type="number" name="is_active" className="form-control" value={formik.values.is_active}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.is_active && !!formik.errors.is_active}
isValid ={!!formik.touched.is_active && !formik.errors.is_active}
></Form.Control>
{
    formik.errors.is_active && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.is_active}</>
    </Form.Control.Feedback>
)}
</Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

